import {Pagination} from '@mui/material'
import {AddModal} from 'organization/Event/Attendants/AddModal'
import {ListAttendant} from 'organization/Event/Attendants/ListAttendant'
import EventPage from 'organization/Event/EventPage'
import {useEventAttendants} from 'organization/Event/Attendants/EventAttendantsProvider'
import BreadcrumMenu from 'organization/theme/Breadcrum'
import React, {useState} from 'react'
import styled from 'styled-components'
import {Invited} from 'organization/Event/Attendants/Invited'
import {EventFaqHelp} from 'organization/Event/Help/FAQ'
import {useOrganizationEvent} from 'organization/Event/OrganizationEventProvider'
import {useI18n} from 'i18n/I18nContext'

export const Attendants = () => {
  const {t} = useI18n()
  const {
    attendants,
    totalPages,
    page,
    changePage,
    searchAtendant,
    total,
    from,
    to,
  } = useEventAttendants()
  const [showModal, setShowModal] = useState<boolean>(false)
  const {event} = useOrganizationEvent()
  const toggleShowModal = () => {
    setShowModal((curr: boolean) => !curr)
  }

  const [timer, setTimer] = useState<any>(null)

  function delayedSearch(change: string) {
    if (timer) {
      clearTimeout(timer)
      setTimer(null)
    }
    setTimer(
      setTimeout(() => {
        searchAtendant(change)
      }, 500),
    )
  }

  return (
    <EventPage modals={<AddModal show={showModal} toggle={toggleShowModal} />}>
      <>
        <div className="row pl-30 pb-30 pr-30">
          <BreadcrumMenu
            title={t('org.attendees.breadcrumbTitle')}
            helpInfo={<EventFaqHelp faqKey="participantsPage" />}
          />

          <div className="col-xxl-12">
            <div className="create__event-area">
              <div className="body__card-wrapper">
                <p style={{fontSize: '1rem'}}>
                  {t('org.attendees.availableSeats')}:{' '}
                  <b>{event?.available_seats}</b>
                </p>

                <div className="attendant__wrapper mb-35">
                  <ButtonsHolder>
                    <div className="singel__input-field mr-15">
                      <input
                        type="email"
                        name="email"
                        placeholder={t('org.attendees.searchPlaceholder')}
                        onChange={(e) => {
                          delayedSearch(e.target.value)
                        }}
                      />
                    </div>

                    <button className="input__btn" onClick={toggleShowModal}>
                      {t('org.attendees.addManually')}
                    </button>
                  </ButtonsHolder>

                  <table>
                    <thead>
                      <tr>
                        <th>{t('org.attendees.colTicketNumber')}</th>
                        <th>{t('org.attendees.colFirstName')}</th>
                        <th>{t('org.attendees.colLastName')}</th>
                        <th>{t('org.attendees.colEmail')}</th>
                        <th>{t('org.attendees.colTicketType')}</th>
                        <th>{/* ACTIONS */}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {attendants.length === 0 && (
                        <tr>
                          <td colSpan={6}>{t('org.attendees.emptyRow')}</td>
                        </tr>
                      )}
                      {attendants &&
                        attendants.map((attendant, index) => (
                          <ListAttendant attendant={attendant} index={index} />
                        ))}
                    </tbody>
                  </table>
                  <PaginationHolder>
                    <div></div>
                    <Pagination
                      count={totalPages}
                      shape="rounded"
                      page={page}
                      onChange={changePage}
                    />
                    <PaginationStats>
                      {from}-{to} {t('org.attendees.paginationMid')} {total}{' '}
                      {t('org.attendees.paginationEnd')}
                    </PaginationStats>
                  </PaginationHolder>
                </div>
              </div>
            </div>
          </div>

          <Invited />
        </div>
      </>
    </EventPage>
  )
}

export const PaginationHolder = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 30px;
`

export const PaginationStats = styled.div`
  color: #6c6c6c;
`

export const ButtonsHolder = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
